

















import { Vue } from '../../constants/constants'
export default Vue.component('rate-comp', {
	name: 'rate-comp',
	computed: {
		stars () {
			let starRating = Array(5).fill(false)
			let normalizedRating = Math.round(this.rating)
			starRating.fill(true, 0, normalizedRating)
			return starRating
		}
	},
	props: {
		rating: {
			type: Number,
			default: 0,
			validator: v => v >= 0 && v <= 5
		}
	}
})
